import React, { useId } from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';

const RequiredFieldIndicator = ({ showError, message = 'Required field', withTooltip = true }) => {
  const tooltipId = useId();
  if (!showError) return null;

  const badge = (
    <span className="ms-2 d-inline-flex align-items-center">
      <Badge
        bg="danger"
        className="rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{ width: '14px', height: '14px', fontSize: '10px', lineHeight: 1 }}
      >
        !
      </Badge>
    </span>
  );

  if (!withTooltip) return badge;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip className="responder-tooltip" id={tooltipId}>
          {message}
        </Tooltip>
      }
    >
      {badge}
    </OverlayTrigger>
  );
};

export default RequiredFieldIndicator;
